import type { contractBook } from "@eulerxyz/core-sdk"
import type {
  BatchResultStatus,
  ContractFunctionResult,
} from "@eulerxyz/evc-sdk"
import { createSelector } from "@reduxjs/toolkit"
import { type Address, getAddress } from "viem"

export type VaultResults = BatchResultStatus<
  ContractFunctionResult<typeof contractBook.vaultLens.abi, "getVaultInfoFull">
>["result"]

export const mapVaultsData = createSelector(
  [(vaults: VaultResults[]) => vaults],
  (vaults) => {
    const data = new Map<Address, VaultResults>()
    vaults.forEach((vault) => {
      if (!vault) return
      data.set(getAddress(vault.vault), vault)
    })

    return data
  },
)
